module.exports = __webpack_public_path__ + "img/img34.d90edbd5.png";